module.exports = __webpack_public_path__ + "static/media/verdanab.16381da5.woff";